var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarrelIconHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-7",
    transform: "translate(-147.000000, -207.000000)",
    fill: "#5F5F5F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(149.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8999939,8.37572954 L19.3609611,8.37572954 L19.3609611,9.47662894 L20.6670187,9.47662894 C20.6670187,8.08222069 20.8219284,7 19.3609611,7 C18.386983,7 17.8999939,7 17.8999939,7 L17.8999939,8.37572954 Z",
    id: "Path-15-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.033959,0.66311192 C10.0937664,0.494916291 7.94558973,0.451090002 6,0.558408816 L6,15.3965194 C7.93568362,15.5291706 10.0709495,15.5349841 12.0030958,15.40994 L12.033959,0.66311192 Z M13.0337522,0.762982025 C15.4642219,1.03951979 17.4137645,1.5215915 17.9582624,2.14892996 L17.9582624,13.9619718 C17.3940967,14.6526537 15.4361725,15.1061512 13.0032618,15.3316359 L13.0337522,0.762982025 Z M5,0.628727406 C2.53542673,0.841816493 0.551487109,1.32785943 -2.80664381e-13,2.14892996 L-2.94875235e-13,13.9619718 C0.576116059,14.626836 2.55217989,15.0808802 5,15.3148388 L5,0.628727406 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrelIconHorizontal);
export default __webpack_public_path__ + "static/media/barrel-icon-horizontal.7e3b39bf49656a9b84e8509bb2880f6c.svg";
export { ForwardRef as ReactComponent };